import {Pipe, PipeTransform} from "@angular/core";
import {Icon} from "@models";

@Pipe({
	name: "filterDefaultBookmarks",
	pure: false,
	standalone: false,
})
export class FilterDefaultBookmarksPipe implements PipeTransform {
	defaultIconFileNames = ["comment-dots-duotone.svg", "thumbs-up-duotone.svg", "exclamation-triangle-duotone.svg"];

	transform(items: Icon[], isDefault: boolean): Icon[] {
		if (!items) {
			return items;
		}
		// filter items array, items which match and return true will be
		// kept, false will be filtered out
		if (isDefault) {
			return items.filter((value) => this.defaultIconFileNames.includes(value?.filepath?.toLowerCase() ?? ""));
		} else {
			return items.filter((value) => !this.defaultIconFileNames.includes(value?.filepath?.toLowerCase() ?? ""));
		}
	}
}
